import styled, {css} from 'styled-components';
import {ErrorMessage} from '../../styled/common';
import {whiteArrowIcon, blackArrowIcon} from '../acommon/StyledIcon';
import Select, {Styles} from 'react-select';
import AsyncSelect from 'react-select/async';
import CreatableSelect from 'react-select/creatable';
import {SelectOptionType} from '../../utils/types';
import {device} from '../../styled/device';

export const selectWidth = '100%';
export const applySelectStyles = (select: any) => styled(select)`
  @media (max-width: 330px) {
    width: ${selectWidth};
  }

  .select__control {
    transition: 0.1s;
    border: 1px solid #a2a2b4;
    min-width: 150px;
    /* background-color: red; */
  }

  & .select__value-container {
    padding: 0;
  }

  & .select__dropdown-indicator {
    padding: 0;
  }

  & .select__single-value,
  & .select__placeholder {
    font-size: 16px;
    margin-left: 0;
    padding-left: 0;

    @media (max-width: ${device.tablet}) {
      font-size: 20px !important;
    }
  }

  & .select__single-value {
    color: #161643;
  }

  & .select__placeholder {
    color: #8181a3;
  }

  & .select__input input {
    margin: 0;
    padding: 0;
    font-size: 16px;
    color: #161643;

    @media (max-width: ${device.tablet}) {
      font-size: 20px !important;
    }
  }

  & .select__option.select__option--is-selected {
    background-color: #fcfcfd;
  }

  & .select__option.select__option--is-focused.select__option--is-selected {
    cursor: default;
    color: #23262f;
    font-weight: 500;
  }

  & .select__option.select__option--is-focused {
    cursor: pointer;
  }

  & .select__menu {
    font-size: 16px;
    width: 100%;
    height: auto;
    min-height: 75px;
    max-height: 322px;
    box-shadow: 0 10px 16px #0f0f0f0d;
    border-radius: 0 0 8px 8px;
    z-index: 4;
    margin-top: 0;

    @media (max-width: ${device.tablet}) {
      font-size: 20px !important;
    }

    @media (max-width: ${device.mobileM}) {
      width: 100%;
      /* background-color: green; */
    }
  }

  & .select__menu-notice {
    color: #161643;
    text-align: left;
    margin-top: 10px;
    font-size: 16px;
  }

  & .select__menu-list {
    padding: 15px 15px 15px 15px;
    /* box-shadow: 0 30px 30px #2148ff1a; */
    min-width: min-content;
    height: auto;
    min-height: 75px;
    max-height: 322px;
    border-radius: 0 0 8px 8px;
    /* background-color: red; */

    @media (max-width: ${device.mobileM}) {
      width: 100%;
      padding: 5px 5px 5px 5px;
    }
  }

  & .select__option {
    display: flex;
    align-items: center;
    text-align: left;
    color: #777e90;
    height: 56px;
    padding-left: 20px;
    box-sizing: border-box;
    background-color: #fcfcfd;
    /* background-color: blue; */

    &:active {
      font-weight: 500;
      background-color: #fcfcfd;
    }

    &:hover {
      color: #23262f;
      font-weight: 500;
      border-radius: 12px;
      background-color: #f4f5f6;
    }

    @media (max-width: ${device.mobileM}) {
      padding-left: 15px;
    }
  }

  & .select__option:last-child {
    border-color: transparent;
    /* background-color: green; */
  }

  // @media (max-width: ${device.tablet}) {
  //   min-width: 100px;
  // }

  // @media (max-width: ${device.mobileS}) {
  //   min-width: 293px;
  // }
  //
  // @media (max-width: ${device.mobileM}) {
  //   min-width: 290px;
  // }
`;

export const styles: Styles<SelectOptionType, boolean> = {
  input: base => ({
    ...base,
    width: 1,
    margin: 0,
    padding: 0,
    fontSize: 16,
    color: '#161643',
  }),
};

export const ReactSelect = applySelectStyles(Select);
export const AsyncReactSelect = applySelectStyles(AsyncSelect);
export const CreatableReactSelect = applySelectStyles(CreatableSelect);

type WrapperProps = {
  disabled?: boolean;
  invalid?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: auto 50px auto;
  cursor: pointer;
  width: 100%;
  margin-bottom: 15px;

  & .select__control {
    grid-row: 2 / 3;
    min-height: 20px;
    cursor: pointer;
    background-color: #fcfcfd;
    box-sizing: border-box;
    box-shadow: none;
    border-radius: 7px;
    transition: background-color 0.5s ease-in-out, border-color 0.05s ease-in-out;
    border: 1px solid ${props => (props.invalid ? '#FF2467' : '#a2a2b4')};

    &,
    &:hover {
      border: 1px solid ${props => (props.invalid ? '#FF2467' : '#a2a2b4')};
    }
  }

  & .select__value-container {
    padding: 0 16px;
  }

  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.3;
    `};
`;

export const Label = styled.label`
  grid-row: 1 / 2;
  text-transform: uppercase;
  font-size: 12px;
  text-align: left;
  user-select: none;
  color: #777e91;
  pointer-events: none;

  @media (max-width: ${device.mobileM}) {
    font-size: 16px;
  }
`;

type DisplayIconProps = {
  shouldRotate: boolean;
};

export const DisplayIcon = styled.img.attrs<DisplayIconProps>(props => ({
  src: props.shouldRotate ? blackArrowIcon : whiteArrowIcon,
  alt: 'Toggle menu',
}))<DisplayIconProps>`
  width: 31px;
  height: 31px;
  cursor: pointer;
  pointer-events: none;
  position: relative;
  border-radius: 50%;
  right: 12px;
  border: none !important;
  user-select: none;
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  width: 16px;
  top: -27px;
  right: 7px;
`;

export const TooltipWrapper = styled.span`
  margin-left: 6px;
  display: inline-block;
  position: relative;
  pointer-events: auto;
`;

export const Error = styled(ErrorMessage)`
  grid-row: 3 / 4;
`;
